<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <v-autocomplete
                v-model="id"
                :items="estados"
                :item-text="show"
                item-value="id"
                :label="title"
                :readonly="readonly"
                :outlined="outlined"
                :dense="dense"
                :multiple="multiple"
                :chips="chips"
                :return-object="returnObject"
            >
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ data.item[show] }}
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="subtitle !== null">
                            {{
                                typeof data.item[subtitle] === "number"
                                    ? formatPrice(data.item[subtitle]) + "€"
                                    : data.item[subtitle]
                            }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="d-flex flex-row">
                        <v-icon
                            v-if="!disabled"
                            @click="openEditDialog(data.item.id)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="EDITAR"
                            >mdi-pencil-outline</v-icon
                        >
                        <template
                            v-if="
                                availableDelete == null ||
                                data.item[availableDelete]
                            "
                        >
                            <v-icon
                                v-if="!disabled"
                                @click="openDeleteDialog(data.item.id)"
                                small
                                class="mr-2"
                                color="red"
                                style="font-size: 25px"
                                title="BORRAR"
                                >mdi-trash-can</v-icon
                            >
                        </template>
                    </v-list-item-action>
                </template>
            </v-autocomplete>

            <template v-if="availableAdd">
                <v-btn
                    v-if="!disabled"
                    :ripple="false"
                    :style="dense ? '' : 'margin-top: 10px'"
                    class="mx-2"
                    fab
                    dark
                    small
                    color="blue"
                    @click="openDialog()"
                >
                    <v-icon style="color: white !important"> mdi-plus </v-icon>
                </v-btn>
            </template>
        </div>

        <DeleteDialog v-model="delete_dialog" @delete="deleteEstado()" />

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear/Editar {{ title }}
                </v-card-title>
                <v-card-text style="text-align: center">
                    <slot></slot>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="error" large @click="dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        v-if="this.update"
                        color="success"
                        large
                        @click="updateEstado()"
                        >Modificar</v-btn
                    >
                    <v-btn v-else color="success" large @click="createEstado()"
                        >Guardar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DeleteDialog from "./DeleteDialog.vue";
import { formatPrice } from "../../utils/formatters";

export default {
    components: {
        DeleteDialog,
    },
    props: {
        value: {
            type: [Number, Array],
            default: null,
        },
        title: {
            type: String,
            default: "",
        },
        estados: {
            type: Array,
            default: [],
        },
        show: {
            type: String,
            default: "",
        },
        subtitle: {
            type: String,
            default: "",
        },
        elemento: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        chips: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        availableAdd: {
            type: Boolean,
            default: true,
        },
        availableDelete: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            delete_dialog: false,
            dialog: false,
            update: false,
            index: -1,
            id: this.multiple ? [] : null,
            selected: null,
        };
    },
    created() {
        if (this.value != null) {
            if (this.multiple) {
                this.id = Array.isArray(this.value) ? this.value : [];
            } else {
                this.id = this.value;
            }
        }
    },
    methods: {
        updateElemento() {
            if (this.multiple) {
                this.$emit("elementoUpdate", [this.id]);
            } else {
                this.$emit("elementoUpdate", this.id);
            }
        },
        closeDialog() {
            this.dialog = false;
            this.delete_dialog = false;
        },
        createEstado() {
            this.$emit("create");
            this.closeDialog();
        },
        deleteEstado() {
            this.$emit("delete", this.selected);
            this.closeDialog();
        },

        updateEstado() {
            this.$emit("update");
            this.closeDialog();
        },
        getIndexOfId(id) {
            for (let i = 0; i < this.estados.length; i++) {
                if (this.estados[i].id == id) {
                    this.index = i;
                    break;
                }
            }
        },
        openDeleteDialog(id) {
            this.delete_dialog = true;
            this.selected = id;
        },
        openDialog() {
            if (this.multiple) {
                this.id = [];
            } else {
                this.id = null;
            }
            this.$emit("clear");

            this.update = false;
            this.dialog = true;
        },

        openEditDialog(id) {
            this.getIndexOfId(id);
            this.selected = id;
            this.$emit("getEstado", this.index);
            this.update = true;
            this.dialog = true;
        },
        formatPrice,
    },
    mounted() {
        //
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (this.multiple) {
                    this.id = Array.isArray(val) ? val : [];
                } else {
                    this.id = val;
                }
            },
        },
        elemento(n) {
            if (this.multiple) {
                this.id = Array.isArray(n) ? n : [];
            } else {
                this.id = n;
            }
        },
        id: {
            handler(val) {
                if (this.multiple) {
                    this.$emit("input", Array.isArray(val) ? val : []);
                } else {
                    this.$emit("input", val);
                }
            },
            deep: true,
        },
    },
};
</script>
